<template>
  <el-drawer class="drawer" :visible.sync="visible" :with-header="false" :before-close="closeFn"
    :close-on-click-modal="false">
    <el-row style="margin-bottom: 20px">
      <el-col :span="23">
        <h1 style="margin-bottom: 20px">
          {{
            order.startStationName +
            "-" +
            order.endStationName +
            " " +
            $utils.timeFn(order.assignTime, "MM-DD") +
            " " +
            order.startLineTime +
            "-" +
            order.endLineTime +
            " 乘客数" +
            order.passengerNum
          }}
        </h1>
      </el-col>
      <el-col :span="1">
        <el-button type="button" class="el-drawer__close-btn" @click="$emit('update:visible', false)">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </el-button>
      </el-col>
    </el-row>

    <el-dialog :title="viewTitle" :visible.sync="viewVisible" width="40%" append-to-body>
      <el-table :data="viewData" :max-height="575" style="width: 100%" border>
        <el-table-column prop="xianlu" width="400" label="参与线路">
        </el-table-column>
        <el-table-column prop="banci" label="已排班次">
          <template slot-scope="{ row }">
            <span>
              {{ row.banci }}
              <el-tag v-if="row.sameShift" type="danger" effect="plain">相同班次
              </el-tag>
              <el-tag v-else-if="row.sameLine" type="success" effect="plain">相同线路
              </el-tag>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :visible.sync="seatSelectionVisible" :title="'请选择' + order.passengerNum + '个座位'" width="20%" append-to-body
      @close="seatCheckList = []" class="zuowei">
      <div style="width: 300px; margin: 0 auto">
        <div class="tip">
          <div class="tipYes"></div>
          <span>可选</span>
        </div>
        <div class="tip">
          <div class="tipNo"></div>
          <span>已购</span>
        </div>
      </div>

      <div class="cont">
        <div class="drivers">
          <div class="driver"></div>
          <p>司机</p>
        </div>

        <div v-for="(item, index) in seatNoAndFeeVos" :key="index" :class="seatNoAndFeeVos.length == 4
            ? 'passe1'
            : seatNoAndFeeVos.length == 6
              ? 'passe2'
              : seatNoAndFeeVos.length == 7
                ? 'passe3'
                : seatNoAndFeeVos.length == 8
                  ? 'passe4'
                  : ''
          ">
          <div class="passenger" :style="{
            'background-image':
              item.isSoldTicket == 1
                ? 'url(' + require('@/assets/img/kexuan1.png') + ')'
                : item.isSoldTicket == 9
                  ? 'url(' + require('@/assets/img/yixuan1.png') + ')'
                  : 'url(' + require('@/assets/img/zuowei2.png') + ')',
          }" @click="seatCheck(item, index)"></div>
          <p>
            {{ item.seatNo }}
          </p>
        </div>
        <div style="text-align: center; margin: 30px auto">
          <el-button type="primary" :disabled="order.passengerNum != seatCheckList.length" @click="dispatchClick"
            :loading="loading">确认改派
          </el-button>
        </div>
      </div>
    </el-dialog>

    <p class="util-remark">只能改派给同一机构下的车辆</p>
    <div style="height: auto">
      <div style="padding-top: 6px">
        <el-select style="width: 100px" v-model="vehicleSeat" placeholder="座位数量" @change="tabClick"
          :disabled="tabClickStatus" clearable>
          <el-option v-for="item in $const.SEATNUMBER" :key="item.value" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
        <el-input style="width: 150px; margin-left: 10px" v-model="licenseNo" placeholder="搜索车辆号牌"
          maxlength="64"></el-input>
        <el-input style="width: 150px; margin-left: 10px" v-model="vehicleNo" placeholder="搜索车辆编号"
          maxlength="64"></el-input>
        <el-input style="width: 150px; margin-left: 10px" v-model="driverName" placeholder="搜索值班司机"
          maxlength="64"></el-input>
        <div style="margin-left: 10px; display: inline-block">
          <el-button type="primary" @click="tabClick">查询</el-button>
          <el-button @click="tabResetFn">重置</el-button>
        </div>
      </div>
      <el-table border ref="tableList" @row-click="chooseClick" :data="table.content" :max-height="575"
        empty-text="该订单机构名称下，无可改派的车辆" style="width: 100%; margin-top: 8px" v-loading="loading">
        <!-- v-loadmore="getVehicleListPush"  -->
        <el-table-column label="机构名称" min-width="100" show-overflow-tooltip prop="organizationName"
          v-if="mixinUserInfo.organizationType === 1">
        </el-table-column>
        <el-table-column label="车辆号牌" min-width="100" show-overflow-tooltip prop="licenseNo">
        </el-table-column>
        <el-table-column label="车辆编号" min-width="100" show-overflow-tooltip prop="vehicleNo">
          <template v-slot="scope">
            {{ scope.row.vehicleNo || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="座位数" min-width="100" show-overflow-tooltip prop="vehicleSeat">
          <template slot-scope="{ row }"> {{ row.vehicleSeat }}座 </template>
        </el-table-column>
        <el-table-column label="值班司机" show-overflow-tooltip min-width="110" prop="driverName">
          <template slot-scope="{ row }">
            {{ row.driverName ? row.driverName : "-" }}
          </template>
        </el-table-column>
        <el-table-column label="已排班数" min-width="100" show-overflow-tooltip prop="schedulingCount">
          <template slot-scope="{ row }">
            <span v-if="row.schedulingCount" style="
                color: #0066ff;
                cursor: pointer;
                text-decoration: underline;
              " @click.stop="lineVehicleListView(row)">
              {{ row.schedulingCount }}
              <el-tag v-show="row.sameLine" type="success" effect="plain">有相同线路
              </el-tag>
            </span>
            <span v-else>空闲</span>
          </template>
        </el-table-column>
        <el-table-column min-width="65" align="center" label="操作">
          <template slot-scope="{ row }">
            <div style="padding: 0;" class="custom-action">
              <template v-if="order.schedulingType == 3">
                <span v-if="row.vehicleSeat - 1 >= order.passengerNum" style="color: #0066ff; cursor: pointer"
                  @click.stop="seatSelection(row)">
                  选择
                </span>
                <span v-else style="color: #999; cursor: pointer"> 选择 </span>
              </template>
              <template v-else>
                <span v-if="row.seatStatus === 1 || row.seatStatus === 2" style="font-size: 14px; color: #999">{{
                  row.seatStatus === 1
                  ? "座位已满"
                  : row.seatStatus === 2
                    ? "所选车辆座位不满足，请选择其他车辆"
                    : ""
                }}</span>
                <i style="margin: auto" v-else class="iconfont" :class="vehicleId === row.vehicleId
                        ? ' icon-checked'
                        : ' icon-choose'
                      "></i></template>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="btn-wrapper">
      <el-button type="primary" @click="dispatchClick" :loading="loading" v-if="order.schedulingType !== 3">选择</el-button>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: "orderVehicle",
  // directives: {
  //   loadmore: {
  //     bind(el, binding, vnode) {
  //       const selectWrap = el.querySelector(".el-table__body-wrapper");
  //       selectWrap.addEventListener("scroll", function () {
  //         const sign = 1;
  //         const scrollDistance =
  //           this.scrollHeight - this.scrollTop - this.clientHeight;
  //         if (scrollDistance <= sign) {
  //           if (vnode.context.loadmoreSwitch) {
  //             binding.value();
  //           }
  //         }
  //       });
  //     },
  //   },
  // },
  props: {
    visible: {
      // 显隐
      default() {
        return false;
      },
    },
    order: {
      // 订单
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      vehicleSeat: null,
      driverName: null,
      licenseNo: null,
      vehicleNo: null,
      tabClickStatus: false,
      // 排班列表
      viewTitle: null,
      viewVisible: false,
      viewData: [],
      lineInfo: {},
      // 选座列表
      seatSelectionTitle: null,
      seatSelectionVisible: false,
      seatNoAndFeeVos: [],
      seatCheckList: [],
      // 配置项
      customOptions: {},
      // 选中的司机id
      driverId: "",
      // 选中的车辆id
      vehicleId: "",
      // 无限加载loading
      loading: false,
      // 车辆列表
      table: {
        content: [],
        total: 0,
      },
    };
  },
  created() {
    // this.mixinOrganizations();
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.show();
        } else {
          this.table = {
            content: [],
            total: 0,
          };
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    noMore() {
      return (
        this.table.total !== 0 && this.table.content.length === this.table.total
      );
    },
  },
  methods: {
    /**
     * 获取订单所属线路信息
     */
    async getLineInfo() {
      let url = "/api/v1/manage/order/dispatch/assign/" + this.order.id;
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.lineInfo = data.data || {};
      }
    },
    // 打开座位选择
    async seatSelection(row) {
      this.driverId = row.driverId;
      this.vehicleId = row.vehicleId;
      let url = "/api/v1/manage/order/dispatch/assign/again/seat";
      let params = {
        driverId: row.driverId,
        vehicleId: row.vehicleId,
        orderLineId: this.lineInfo.orderLineId,
      };
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        this.seatSelectionVisible = true;
        this.seatNoAndFeeVos = data.data || [];
      }
    },
    // 选择座位
    seatCheck(item, index) {
      if (item.isSoldTicket == 1) {
        if (this.seatCheckList.length >= this.order.passengerNum) {
          this.$message.warning("选座不可超出乘客数量");
          return;
        } else {
          this.seatCheckList.push(item.seatNo);
          this.seatNoAndFeeVos[index].isSoldTicket = 9;
        }
      } else {
        this.seatCheckList.forEach((seatNo, i) => {
          if (seatNo == item.seatNo) {
            this.seatCheckList.splice(i, 1);
            this.seatNoAndFeeVos[index].isSoldTicket = 1;
          }
        });
      }
    },
    /**
     * 选择车辆司机
     */
    chooseClick(row) {
      if (row.seatStatus === 1 || row.seatStatus === 2) {
        return;
      }
      this.driverId = row.driverId;
      this.vehicleId = row.vehicleId;
    },
    /* 接口调用-指派 */
    async dispatchClick() {
      if (!this.vehicleId || !this.driverId) {
        this.$message.warning("请选择车辆");
        return;
      }
      if (
        this.seatCheckList.length > 0 &&
        this.order.passengerNum != this.seatCheckList.length
      ) {
        this.$message.warning("选择的座位数与乘客数不相同");
        return;
      }
      let url = "/api/v1/manage/order/dispatch/assign/again";
      let params = {
        orderId: this.order.id,
        orderLineId: this.lineInfo.orderLineId,
        driverId: this.driverId,
        vehicleId: this.vehicleId,
        seatNo: this.seatCheckList.join(","),
      };
      this.loading = true;
      let data = await this.$axios.post(url, params);
      this.loading = false;
      if (data && data.code === 1) {
        this.$message.success("指派成功");
        this.seatSelectionVisible = false;
        this.$emit("update:visible", false);
        this.$emit("confirm");
      }
    },
    /**
     * 当某一行被点击时会触发该事件
     */
    async show() {
      // 清除司机车辆选中状态
      this.driverId = "";
      this.vehicleId = "";
      await this.getLineInfo();
      this.customOptions.lineId = this.lineInfo.id;
      this.customOptions.schedulingId = this.lineInfo.schedulingId;
      this.customOptions.orderId = this.order.id;
      this.customOptions.driverId = this.order.driverId; // 改派特定
      this.customOptions.vehicleId = this.order.vehicleId; // 改派特定
      this.customOptions.organizationId = this.order.organizationId; // 改派特定
      this.getVehicleList();
    },
    /**
     * 切换车辆类型
     */
    async tabClick() {
      this.table = {
        content: [],
        total: 0,
      };
      this.tabClickStatus = true;
      await this.getVehicleList();
      this.tabClickStatus = false;
    },
    async tabResetFn() {
      this.vehicleSeat = null;
      this.driverName = null;
      this.licenseNo = null;
      this.vehicleNo = null;
      this.driverId = null
      this.vehicleId = null
      this.table = {
        content: [],
        total: 0,
      };
      this.tabClickStatus = true;
      await this.getVehicleList();
      this.tabClickStatus = false;
    },
    /**
     * 车辆列表部分
     */
    async getVehicleList() {
      this.loading = true;
      let url = "/api/v1/manage/order/dispatch/queryVehicleList";
      let params = {
        ...this.customOptions,
        schedulingType: this.order.schedulingType,
        vehicleSeat: this.vehicleSeat,
        driverName: this.driverName,
        licenseNo: this.licenseNo,
        vehicleNo: this.vehicleNo,
      };
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        // 判断是不是有相同班次
        data.data.forEach((obj) => {
          obj.sameLine = false;
          if (obj.schedulingList) {
            obj.schedulingList.forEach((item) => {
              if (item.lineId == this.lineInfo.lineId) {
                item.sort = 1;
                obj.sameLine = true;
                item.sameLine = true;
              } else {
                item.sort = 0;
              }

              if (item.schedulingId == this.lineInfo.schedulingId) {
                item.sort = 2;
                item.sameShift = true;
              }
            });
            obj.schedulingList.sort((a, b) => {
              return b.sort - a.sort;
            });
          }
        });

        data.data.forEach((obj) => {
          if (obj.sameLine) {
            obj.sort = 1;
          } else {
            obj.sort = 0;
          }
        });

        data.data.sort((a, b) => {
          return b.sort - a.sort;
        });

        this.table = {
          content: data.data,
          total: data.total || 0,
        };
      }
      this.loading = false;
    },
    /**
     * 车辆列表滚动分页
     */
    async getVehicleListPush() {
      if (this.table.total <= this.pages.page * this.pages.size) {
        return;
      }
      this.loading = true;
      let url = "/api/v1/manage/order/dispatch/queryVehicleList";
      this.pages.page = this.pages.page + 1;
      let params = {
        ...this.customOptions,
        schedulingType: this.order.schedulingType,
        ...this.pages,
      };
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1) {
        // 判断是不是有相同班次
        data.data.forEach((obj) => {
          obj.sameLine = false;
          if (obj.schedulingList) {
            obj.schedulingList.forEach((item) => {
              if (item.lineId == this.lineInfo.lineId) {
                item.sort = 1;
                obj.sameLine = true;
                item.sameLine = true;
              } else {
                item.sort = 0;
              }

              if (item.schedulingId == this.lineInfo.schedulingId) {
                item.sort = 2;
                item.sameShift = true;
              }
            });
            obj.schedulingList.sort((a, b) => {
              return b.sort - a.sort;
            });
          }
        });

        data.data.forEach((obj) => {
          if (obj.sameLine) {
            obj.sort = 1;
          } else {
            obj.sort = 0;
          }
        });

        data.data.sort((a, b) => {
          return b.sort - a.sort;
        });

        this.table = {
          content: this.table.content.concat(data.data),
          total: data.total || 0,
        };
      }
      this.loading = false;
    },
    // 班次信息
    async lineVehicleListView(row) {
      row.schedulingList.forEach((item) => {
        item.xianlu = item.startStationName + " - " + item.endStationName;
        item.banci =
          this.$utils.timeFn(item.schedulingTime, "MM-DD") +
          " " +
          item.startTime +
          "-" +
          item.endTime;
      });
      this.viewData = row.schedulingList || [];
      this.viewTitle =
        row.licenseNo + " " + row.vehicleSeat + "座 " + row.driverName;
      this.viewVisible = true;
    },
    closeFn(done) {
      this.$emit("update:visible", false);
      done(false);
    },
  },
};
</script>

<style lang="less" scoped>
.drawer /deep/ .el-drawer {
  width: 55% !important;
}

.zuowei {
  .tip {
    display: inline-block;
    width: 35%;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    margin: 30px 0;
    color: #333333;

    &:nth-child(1) {
      margin-left: 15%;
    }

    &:nth-child(2) {
      margin-right: 15%;
    }

    .tipYes {
      width: 20px;
      height: 20px;
      display: inline-block;
      background: url("../../../assets/img/kexuan1.png") 100% 100%;
      background-size: 20px;
      vertical-align: middle;
    }

    .tipNo {
      width: 20px;
      height: 20px;
      display: inline-block;
      background: url("../../../assets/img/zuowei2.png") 100% 100%;
      background-size: 20px;
      vertical-align: middle;
    }

    span {
      vertical-align: middle;
      margin-left: 10px;
    }
  }

  .cont {
    flex-wrap: wrap;
    width: 300px;
    margin: 0 auto;

    .drivers {
      display: inline-block;
      width: 35%;
      margin-left: 15%;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
    }

    .driver {
      display: inline-block;
      width: 40px;
      height: 40px;
      margin-top: 10px;
      background-image: url("../../../assets/img/zuowei2.png");
      background-repeat: no-repeat;
      background-size: 100%;
    }

    .passenger {
      width: 40px;
      height: 40px;
      display: inline-block;
      cursor: pointer;
      background-repeat: no-repeat;
      background-size: 100%;
    }

    .passe1 {
      display: inline-block;
      text-align: center;
      margin-top: 10px;

      >p {
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
      }

      &:nth-child(2) {
        width: 35%;
        margin-right: 15%;
      }

      &:nth-child(3) {
        width: 33.33%;
      }

      &:nth-child(4) {
        width: 33.33%;
      }

      &:nth-child(5) {
        width: 33.33%;
      }
    }

    .passe2 {
      display: inline-block;
      text-align: center;
      margin-top: 10px;

      >p {
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
      }

      &:nth-child(2) {
        width: 35%;
        margin-right: 15%;
      }

      &:nth-child(3) {
        width: 35%;
        margin-left: 15%;
      }

      &:nth-child(4) {
        width: 35%;
        margin-right: 15%;
      }

      &:nth-child(5) {
        width: 33.33%;
      }

      &:nth-child(6) {
        width: 33.33%;
      }

      &:nth-child(7) {
        width: 33.33%;
      }
    }

    .passe3 {
      display: inline-block;
      text-align: center;
      margin-top: 10px;

      >p {
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
      }

      &:nth-child(2) {
        width: 35%;
        margin-right: 15%;
      }

      &:nth-child(3) {
        width: 33.33%;
      }

      &:nth-child(4) {
        width: 33.33%;
      }

      &:nth-child(5) {
        width: 33.33%;
      }

      &:nth-child(6) {
        width: 33.33%;
      }

      &:nth-child(7) {
        width: 33.33%;
      }

      &:nth-child(8) {
        width: 33.33%;
      }
    }

    .passe4 {
      display: inline-block;
      text-align: center;
      margin-top: 10px;

      >p {
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
      }

      &:nth-child(2) {
        width: 35%;
        margin-right: 15%;
      }

      &:nth-child(3) {
        width: 35%;
        margin-left: 15%;
      }

      &:nth-child(4) {
        width: 35%;
        margin-right: 15%;
      }

      &:nth-child(5) {
        width: 35%;
        margin-left: 15%;
      }

      &:nth-child(6) {
        width: 35%;
        margin-right: 15%;
      }

      &:nth-child(7) {
        width: 33.33%;
      }

      &:nth-child(8) {
        width: 33.33%;
      }

      &:nth-child(9) {
        width: 33.33%;
      }
    }
  }
}

.btn-wrapper {
  text-align: center;
  margin: 20px;

  .el-button {
    width: 300px;
    height: 35px;
  }
}
</style>
